import React from 'react';
import SitemapChangeFreqInput from '../../../components/SitemapChangeFreqInput.js';

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
};

class FormSelect extends React.Component {
    render(){
        const field = this.props.field ? this.props.field : 'changefreq';
        return SitemapChangeFreqInput(this.props.initialValue, this.props.getFieldDecorator, formItemLayout, field, this.props.update);
    }
}

export default FormSelect;


// WEBPACK FOOTER //
// ./src/containers/Pages/Partials/FormSelect.js